import React from 'react'

export default function Header() {
    return (
        <header className='header'>
            Products
        </header>
    )
}
